export enum PreInspectionFormStatus {
  Valid,
  Invalid,
  Expired,
  NotFound
}

export enum PreInspectionStatus {
  Ok = 'ok',
  Denied = 'denied'
}

export interface PreInspection {
  plate: string;
  countryCode: string;
  createdAt: string;
  updatedAt: string;
  currentInspection: {
    validity: {
      start: string;
      end: string;
    };
    companies: {
      name: string;
      status: PreInspectionStatus;
      reason: string;
      provider: string;
    }[];
  };
}
